import { Component } from '@verndale/core';

class AdvancedOptions extends Component {
  setupDefaults() {
    this.dom = {
      inputs: [
        ...this.el.querySelectorAll('.checkbox-stack input, .radio-stack input')
      ],
      tagList: this.el.querySelector('.search-tags')
    };

    this.selectedTabs = [];
  }

  addListeners() {
    this.dom.inputs.forEach(input => {
      input.addEventListener('change', this.handleChange.bind(this));
    });
    this.dom.tagList.addEventListener('click', this.handleRemove.bind(this));
  }

  handleChange(e) {
    if (e.target.checked) {
      this.selectedTabs.push(e.target.value);
    } else {
      this.selectedTabs = this.selectedTabs.filter(
        tag => tag !== e.target.value
      );
    }

    this.renderTags();
  }

  renderTags() {
    if (!this.selectedTabs.length) {
      this.dom.tagList.innerHTML = '';
      return;
    }

    const html = this.selectedTabs.map(
      tag => `
    <div class="tag">
      <span class="tag-name">${tag}</span>
      <a class="close" data-remove="${tag}">X</a>
    </div>
    `
    );
    this.dom.tagList.innerHTML = `${html.join('')}
    <div class="clear-button small-8 column">
      <a class="clear-all">Clear All</a>
    </div>`;
  }

  handleRemove(e) {
    if (e.target.dataset.remove) {
      this.selectedTabs = this.selectedTabs.filter(
        tag => tag !== e.target.dataset.remove
      );

      // uselect checkbox or radio
      const input = this.el.querySelector(
        `input[value="${e.target.dataset.remove}"]`
      );
      const event = new Event('change');
      input.checked = false;
      input.dispatchEvent(event);

      this.renderTags();
    } else if (e.target.classList.contains('clear-all')) {
      this.selectedTabs = [];
      this.dom.inputs.forEach(input => {
        const event = new Event('change');
        input.checked = false;
        input.dispatchEvent(event);
      });
      this.renderTags();
    }
  }
}

export default AdvancedOptions;
